// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__85r2g","sidebar":"Sidebar_sidebar__leoJc","backdrop":"Sidebar_backdrop__FjFVU"};